import { render, staticRenderFns } from "./SelectRecd.vue?vue&type=template&id=1821eb39&scoped=true&"
import script from "./SelectRecd.vue?vue&type=script&lang=js&"
export * from "./SelectRecd.vue?vue&type=script&lang=js&"
import style0 from "./SelectRecd.vue?vue&type=style&index=0&id=1821eb39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1821eb39",
  null
  
)

export default component.exports